<template>
  <section class="test mt-4 p-4 container">
    <div class="">
      <infoDownAboutSlider />
    </div>
    <div class="newsParageraph d-flex flex-column">
      <!-- <h2 class="text-color-theme font-bold fontsize-16 weight-bold mb-3">
        ما بهترین کیفیت را برای شما به ارمغان می آوریم.
      </h2> -->
      <div
        class="d-flex flex-column flex-lg-row justify-content-lg-between align-items-lg-baseline gap-lg-40 w-100"
      >
        <h5 class="text-color-444 my-lg-4 font-weight-bold fontsize-16">
          <span class="font-weight-bold">موفقیت‌ها</span>
        </h5>
        <span class="line-about d-none d-lg-block mx-3"></span>
        <p class="text-color-999">جلب اعتماد و رشد بی‌وقفه</p>
      </div>
      <p class="line-height2 fontsize16 text-justify">
        بعد از سال‌ها تلاش، امروز بندیتو نه‌تنها به یک برند شناخته‌شده در حوزه
        روغن‌های گیاهی و طبیعی تبدیل شده، بلکه هزاران نفر از مشتریان وفادار، با
        اطمینان کامل از محصولات ما استفاده می‌کنند. برخی از موفقیت‌های ما:
      </p>
      <p class="line-height2 fontsize16 text-justify">
        ✅ توسعه فرمولاسیون انحصاری برای روغن‌های ترکیبی که اثرگذاری بالایی
        دارند.
      </p>
      <p class="line-height2 fontsize16 text-justify">
        ✅ افزایش اعتماد مشتریان از طریق نمایش کامل فرآیند تولید و ارائه محصولات
        خالص و بدون افزودنی.
      </p>
      <p class="line-height2 fontsize16 text-justify">
        ✅ راه‌اندازی باشگاه مشتریان بندیتو که به کاربران فعال پاداش و امتیاز
        می‌دهد.
      </p>
      <p class="line-height2 fontsize16 text-justify">
        ✅ افزایش آگاهی در مورد سبک زندگی سالم و استفاده از محصولات گیاهی از
        طریق شبکه‌های اجتماعی و محتوای آموزشی. ما باور داریم که زیبایی واقعی از
        درون می‌آید، از مواد خالصی که به بدن خود می‌رسانیم و از طبیعتی که در
        زندگی روزمره‌مان جریان دارد.
      </p>
    </div>
  </section>
</template>
<script>
import infoDownAboutSlider from "@/parts/Front/components/about-us/info-down-about-slider";

export default {
  components: {
    infoDownAboutSlider,
  },
};
</script>
<style scoped>
.line-about {
  height: 1px;
  background-color: #e7e7e7;
  flex-grow: 1;
}
.test {
}
.test div:nth-child(1) {
  float: right;
  margin: 0 0 10px 26px;
  width: 500px;
}
.test div:nth-child(2) {
  text-align: justify;
  line-height: 2;
}
@media screen and (max-width: 992px) {
  .test div:nth-child(1) {
    float: unset !important;
    width: 100%;
  }
  .newsParageraph {
    margin-top: 2rem;
  }
  .newsParageraph h2 {
    font-size: 24px;
  }
}
</style>
